"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class InstantaneousTelemetry extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetTelemetry';
        this.isListening = true;
        this._value = initParams.value;
        this._time = initParams.time;
    }
    set value(value) {
        console.error('Do not set objects this way');
    }
    get value() {
        return this._value;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
}
exports.default = InstantaneousTelemetry;
//# sourceMappingURL=instantaneousTelemetry.js.map